import {
  AccessibilityWrapper,
  AccessibilityContent,
  Title,
  Subtitle,
  Section,
  List,
  ListItem
} from './styles';

const Accessibility = () => {
  return (
    <AccessibilityWrapper>
      <AccessibilityContent>
        <Title>הצהרת נגישות</Title>
        <Subtitle>
          אתר זה עומד בדרישות תקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע"ג 2013
        </Subtitle>

        <Section>
          <h2>אמצעי נגישות</h2>
          <List>
            <ListItem>התאמה לניווט מקלדת</ListItem>
            <ListItem>תמיכה בתוכנת קורא מסך</ListItem>
            <ListItem>אפשרות להגדלת טקסט</ListItem>
            <ListItem>אפשרות לשינוי ניגודיות</ListItem>
            <ListItem>תמיכה בפונט נגיש לדיסלקציה</ListItem>
            <ListItem>תיאורי תמונות חלופיים</ListItem>
          </List>
        </Section>

        <Section>
          <h2>יצירת קשר</h2>
          <p>
            רכז הנגישות באתר: אפיק לב<br />
            טלפון: 054-882-7511<br />
            דוא"ל: afiklev@gmail.com
          </p>
        </Section>

        <Section>
          <h2>מידע נוסף</h2>
          <p>
            האתר נבדק על ידי יועץ נגישות מוסמך ונמצא נגיש לאנשים עם מוגבלויות על פי הנחיות הנגישות המקובלות בישראל: תקן ישראלי 5568 לנגישות אתרי אינטרנט.
          </p>
        </Section>
      </AccessibilityContent>
    </AccessibilityWrapper>
  );
};

export default Accessibility; 